import { Injectable } from '@angular/core';
import { of, Observable, throwError } from 'rxjs';

import { ICustomPageToolbarResolver, ICustomPageToolbar } from './toolbar-data';
import { RouterDataService } from '../../utils/routing/router-data.service';

@Injectable()
export class RouteToolbarResolver implements ICustomPageToolbarResolver {
    constructor(private routerDataService: RouterDataService) {}

    getToolbar(): Observable<ICustomPageToolbar> {
        const data = this.routerDataService.data;

        if (!data || !data.toolbar) {
            return throwError(() => new Error('Missing custom page toolbar configuration.'));
        }

        return of(data.toolbar);
    }
}
